// Campus photo for /colleges/east-carolina-university: CC BY 2.0, by Brent Hoard from USA, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AECU_-_Lawn_(3695021456).jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/east-carolina-university/; credited under the photo.
const photo = {
    "slug": "east-carolina-university",
    "alt": "The campus lawn at East Carolina University in Greenville, North Carolina, with tall shade trees and the domed cupola",
    "src": "/colleges/east-carolina-university/campus-1600.webp",
    "srcSmall": "/colleges/east-carolina-university/campus-800.webp",
    "srcMid": "/colleges/east-carolina-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/east-carolina-university/og.jpg",
    "title": "ECU - Lawn (3695021456)",
    "author": "Brent Hoard from USA",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AECU_-_Lawn_(3695021456).jpg",
    "read": "2026-10-02"
};

export default photo;
